export default __webpack_public_path__ + "static/media/cloud.a2700786.svg";